import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [hoveredLink, setHoveredLink] = useState(null);
  const [hoveredIcon, setHoveredIcon] = useState(null);

  // Inject responsive styles
  useEffect(() => {
    const styleId = 'footer-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .footer-container {
          background-color: #0A0A0A;
          padding: 400px 20px 200px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-family: 'TASA Orbiter Display', sans-serif;
        }
        
        .footer-nav {
          width: 50vw;
          display: flex;
          justify-content: space-between;
          margin-top: 200px;
        }
        
        @media (max-width: 768px) {
          .footer-container {
            padding: 200px 20px 100px 20px;
          }
          
          .footer-nav {
            width: 90vw;
            margin-top: 100px;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  const socialLinks = [
    {
      name: 'instagram',
      url: 'https://www.instagram.com/rtk.artistry',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
    },
    {
      name: 'pinterest',
      url: 'https://www.pinterest.com/rtkartistry/',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-6.627 0-12 5.372-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
        </svg>
      ),
    },
    {
      name: 'kofi',
      url: 'https://ko-fi.com/V7V6ZGF24',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.658-3.734 4.352.24 7.422-2.831 6.649-6.916zm-11.062 3.511c-1.246 1.453-4.011 3.976-4.011 3.976s-.121.119-.31.023c-.076-.057-.108-.09-.108-.09-.443-.441-3.368-3.049-4.034-3.954-.709-.965-1.041-2.7-.091-3.71.951-1.01 3.005-1.086 4.363.407 0 0 1.565-1.782 3.468-.963 1.904.82 1.832 3.011.723 4.311zm6.173.478c-.928.116-1.682.028-1.682.028V7.284h1.77s1.971.551 1.971 2.638c0 1.913-.985 2.667-2.059 3.015z"/>
        </svg>
      ),
    },
  ];

  const navLinks = [
    { name: 'Shipping', url: '/shipping' },
    { name: 'Returns', url: '/returns' },
    { name: 'Privacy', url: '/privacy' },
    { name: 'Contact', url: '/contact' },
  ];

  return (
    <footer className="footer-container">
      {/* Logo */}
      <div style={{ marginBottom: '16px' }}>
        <img 
          src="/logo.png" 
          alt="Rtk Logo" 
          style={{
            height: '240px',
            width: 'auto',
          }}
        />
      </div>

      {/* Brand Name */}
      <p style={{
        color: '#F1F1F1',
        fontSize: '16px',
        fontWeight: '400',
        marginBottom: '32px',
        letterSpacing: '0.05em',
      }}>
        Rtk
      </p>

      {/* Social Icons */}
      <div style={{
        display: 'flex',
        gap: '24px',
        marginBottom: '60px',
      }}>
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setHoveredIcon(social.name)}
            onMouseLeave={() => setHoveredIcon(null)}
            style={{
              color: hoveredIcon === social.name ? '#F1F1F1' : '#8A8A8A',
              transition: 'color 0.2s ease',
            }}
          >
            {social.icon}
          </a>
        ))}
      </div>

      {/* Navigation Links */}
      <nav className="footer-nav">
        {navLinks.map((link) => (
          <Link
            key={link.name}
            to={link.url}
            onMouseEnter={() => setHoveredLink(link.name)}
            onMouseLeave={() => setHoveredLink(null)}
            style={{
              color: hoveredLink === link.name ? '#F1F1F1' : '#6F6F6F',
              textDecoration: 'none',
              fontSize: '13px',
              fontWeight: '400',
              letterSpacing: '0.01em',
              transition: 'color 0.2s ease',
            }}
          >
            {link.name}
          </Link>
        ))}
      </nav>
    </footer>
  );
};

export default Footer;